<template>
  <main v-if="$page">
    <PageHeader :content="$page.header" />
    <ListSection :content="$page.legacy" list="services" />
    <ListSection :content="$page.conciergerie" list="services" />
    <ImageCTASection
      :content="$page.courses"
      :link="$page.courses_link"
      :page="$page.courses_page"
      reverse
    />
    <ImageCTASection
      :content="$page.momentum"
      :link="$page.momentum_link"
      :page="$page.momentum_page"
    />
    <CTASection
      :content="$page.services"
      :link="$page.services_link"
      :page="$page.services_page"
      class="--light"
    />
  </main>
</template>

<script>
import CTASection from '@/components/sections/CTASection.vue'
import ImageCTASection from '@/components/sections/ImageCTASection.vue'
import ListSection from '@/components/sections/ListSection.vue'
import PageHeader from '@/components/sections/PageHeader.vue'
import PageMetaMixin from '@/mixins/PageMetaMixin.js'

export default {
  name: 'Advantages',
  beetPage: 'perks',
  mixins: [PageMetaMixin],
  components: { CTASection, ImageCTASection, ListSection, PageHeader },
}
</script>
